'use strict';

var intellidealerAppShoppingCartModule = angular.module('intellidealerApp.shoppingCart',
                                                        ['intellidealerApp.core']);
